import { QueryModelTypeArgs } from '../generated';
import {
  prepareDataForApolloCache,
  QueryInfo,
} from '../prepareDataForApolloCache';
import { clientVersion } from '@trello/config';
import { parseNetworkError } from '@trello/graphql-error-handling';

export const modelTypeResolver = async (
  _parent: unknown,
  args: QueryModelTypeArgs,
  _context: unknown,
  info: QueryInfo,
) => {
  const apiUrl = `/1/types/${args.idOrName}`;

  const response = await fetch(apiUrl, {
    headers: {
      'Content-Type': 'application/json',
      'X-Trello-Client-Version': clientVersion,
    },
    credentials: 'include',
  });

  if (response.ok) {
    return prepareDataForApolloCache(await response.json(), info);
  }

  throw await parseNetworkError(response);
};
